const allNotification = { data: [], loading: true };
export const GetAllNotification = (state = allNotification, action) => {
  switch (action.type) {
    case "get_allNotification":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

export const GetPendingNotification = (state = { data: [], loading: true }, action = {}) => {
  switch (action.type) {
    case "get_allPendingNotification":
      return {
        data: action.payload.Data,
        loading: action.loader || false,
      };
    default:
      return state;
  }
};

export const GetAllNotificationNew = (
  state = {
    data: {
      data: [],
      pagination: {},
      message: "",
      success: false,
    },
    loading: true,
  },
  action = {},
) => {
  switch (action.type) {
    case "get_allNotification_new":
      const isFirstPage = action.pageNumber === 1;

      return {
        data: {
          ...state.data,
          data: isFirstPage ? action.payload.data : [...state.data.data, ...action.payload.data],
          pagination: action.payload.pagination || state.data.pagination,
          message: action.payload.message || state.data.message,
          success: action.payload.success || state.data.success,
        },
        loading: action.loader || false,
      };
    default:
      return state;
  }
};
